export default __webpack_public_path__ + "static/media/help.1c46d6ea.svg";